module.exports = __webpack_public_path__ + "assets/03a0c06bd8a73f25063127472c152467.json";